export default __webpack_public_path__ + "static/media/greImage.27db976f.jpeg";